<template>
    <div>
        <div :class="`imgs-slide imgs-slide-${random}`">
            <div class="swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="src in srcs" :key="src">
                        <v-card flat rounded="lg" class="imgs-slide__img" target="_blank" :href="src">
                            <v-img v-bind="{ src }" :aspect-ratio="368 / 217" width="100%" />
                        </v-card>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Swiper from "swiper/bundle";

export default {
    props: {
        srcs: { type: Array, default: () => [] },
    },
    data: () => ({
        random: Math.random().toFixed(10).slice(2, 12),
        swiper: undefined,
        selectedIndex: 0,
        Math,
    }),
    computed: {
        disable_prev() {
            return this.selectedIndex < 1;
        },
        disable_next() {
            return this.selectedIndex >= this.srcs.length - 1;
        },
    },
    watch: {
        showsDialog() {
            this.$refs["nav"]?.$forceUpdate?.();
            this.$nextTick(() => this.$refs?.["nav"]?.setWidths?.());
            this.init();
        },
        selectedIndex() {
            if (this.selectedIndex >= this.srcs.length) this.selectedIndex = this.srcs.length - 1;
            if (this.selectedIndex < 0) this.selectedIndex = 0;
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        setIndex(index) {
            this.selectedIndex = index;
        },
        goPrev() {
            if (this.selectedIndex > 0) this.selectedIndex -= 1;
        },
        goNext() {
            if (this.selectedIndex < this.srcs.length - 1) this.selectedIndex += 1;
        },
        async init() {
            this.$nextTick(() => {
                new Swiper(`.imgs-slide-${this.random} .swiper-container`, {
                    observer: true,
                    observeParents: true,
                    spaceBetween: 10,
                    slidesPerView: 2,
                    freeMode: true,
                    watchSlidesProgress: true,
                    breakpoints: {
                        576: {
                            spaceBetween: 10,
                            slidesPerView: 3,
                        },
                        1024: {
                            spaceBetween: 24,
                            slidesPerView: 3,
                        },
                    },
                });
            });
        },
    },
};
</script>
